<template>
  <div>
    <!--添加告警规则-->
    <el-dialog :visible.sync="addAlarmRuleDialogVisible" title="添加告警规则" @close="feedBack" v-if="addAlarmRuleDialogVisible">
      <el-form :label-position="labelPosition" label-width="80px">
        <el-form-item label="规则名称">
          <el-input v-model="AddAlarmRule.params.alarmRuleName"></el-input>
        </el-form-item>
        <el-form-item label="检测字段">
          <el-select v-model="AddAlarmRule.params.alarmAttribute" style="width: 100%;" @change=" getSensorNum">
            <el-option v-for="item in keyList" :value="item" :label="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字段编号">
          <el-input v-model="AddAlarmRule.params.alarmSensorNum" readonly></el-input>
        </el-form-item>
        <el-card shadow="hover">
          <p style="color: red; text-align: center; width: 100%;">规则为不合理值</p>
          <el-form-item label="运算符号">
            <el-select v-model="AddAlarmRule.params.symbol" style="width: 100%">
              <el-option value=">" label=">"></el-option>
              <el-option value="<" label="<"></el-option>
              <el-option value=">=" label=">="></el-option>
              <el-option value="<=" label="<="></el-option>
              <el-option value="=" label="="></el-option>
              <el-option value="range in" label="range in"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参数1">
            <el-input v-model="AddAlarmRule.params.parameter1" oninput="value=value.replace(/[^\d.]/g, '')">
              <template slot="append">{{unit}}</template>
            </el-input>
          </el-form-item>
          <el-form-item label="参数2">
            <el-input v-model="AddAlarmRule.params.parameter2" oninput="value=value.replace(/[^\d.]/g, '')" :disabled="param2Disable">
              <template slot="append">{{unit}}</template>
            </el-input>
          </el-form-item>
          <el-form-item label="告警规则描述">
            <el-input v-model="AddAlarmRule.params.description" type="textarea" :row="2"></el-input>
          </el-form-item>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="feedBack">取 消</el-button>
        <el-button type="primary" @click="addAlarmRule">确定添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddAlarmRule',
  props:['addAlarmRuleDialogVisible'],
  data() {
    return {
      param2Disable:true,
      labelPosition:'top',
      // 添加告警规则
      AddAlarmRule:{
        "version": 1,
        "method": "alarm.AddAlarmRule",
        "params": {
          "alarmRuleName": "",
          "alarmAttribute": "",
          "alarmSensorNum":"",
          "symbol": "",
          "parameter1":"",
          "parameter2":"",
          "description":""
        },
        "token": "",
        "id": 0
      },
      // 获取动态数据的数据字段
      GetDataKey:{
        "version": 1,
        "method": "sensor.GetSensorValue",
        "params": null,
        "token": "",
        "id": 0
      },
      keyList:[],
      unit:'',
      showTip: false,

    }
  },
  methods: {
    showTip(){
      console.log('showTip');
    },
    getDataKey(){
      this.GetDataKey.token =  localStorage.getItem('token');
      this.$axios.post(this.$mainUrl, this.GetDataKey).then(res=>{
        let array=[]
        if(res.data.hasOwnProperty('result')){
          for(let i=0;i<res.data.result.sensorValueList.length;i++){
            array[i] = res.data.result.sensorValueList[i].sensorValue
          }
          this.keyList = array;
        }else{
          this.$message({
            type: 'error',
            message: '获取动态数据的数据字段失败，' + res.data.error.message
          })
        }
      })
    },
    getSensorNum(){
      this.GetDataKey.token =  localStorage.getItem('token');
      this.$axios.post(this.$mainUrl, this.GetDataKey).then(res=>{

        if(res.data.hasOwnProperty('result')){
          for(let i=0;i<res.data.result.sensorValueList.length;i++){
            if(res.data.result.sensorValueList[i].sensorValue == this.AddAlarmRule.params.alarmAttribute){
              this.AddAlarmRule.params.alarmSensorNum = res.data.result.sensorValueList[i].sensorNum
            }
          }
        }else{
          alert("接口异常！")
        }
      })
    },
    addAlarmRule(){
      this.AddAlarmRule.token = this.$store.state.token;
      this.AddAlarmRule.params.alarmSensorNum = parseFloat(this.AddAlarmRule.params.alarmSensorNum);
      for(let key in this.AddAlarmRule.params){
        if(this.AddAlarmRule.params[key] === ""){
          this.AddAlarmRule.params[key] = null;
        }
      }
      this.AddAlarmRule.params.parameter1 = parseFloat(this.AddAlarmRule.params.parameter1);
      if(this.AddAlarmRule.params.symbol === 'range in'){
        this.AddAlarmRule.params.parameter2 = parseFloat(this.AddAlarmRule.params.parameter2);
      }
      console.log('添加告警规则请求');
      console.log(this.AddAlarmRule);
      this.$axios.post(this.$mainUrl, this.AddAlarmRule).then(res=>{
        console.log('添加告警规则请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'添加告警规则成功'
          })
          this.feedBack();
        }else{
          this.$message({
            type:'error',
            message:'添加告警规则失败，' + res.data.error.message
          })
        }
      })
    },

    feedBack(){
      this.addAlarmRuleDialogVisible = false;
      this.$emit('feedBack', this.addAlarmRuleDialogVisible);
    }
  },
  watch:{
    addAlarmRuleDialogVisible(newValue, oldValue){
      this.getDataKey();


    },
    'AddAlarmRule.params.symbol'(newValue, oldValue){
      if(newValue === 'range in'){
        this.param2Disable = false;
      }else{
        this.param2Disable = true;
      }
    },
    'AddAlarmRule.params.alarmAttribute'(newValue, oldValue){
      let unit = "";
      switch (newValue) {
        case "室外环境声": unit = 'dB';break;
        case  "室外温度": unit= '℃'; break;
        case  "室外湿度":unit= '%'; break;
        case  "室外颗粒物浓度":unit= 'μg/m³'; break;
        case  "室外电池电量":unit= ' %'; break;
        case  "室内温度":unit= '℃'; break;
        case  "室内湿度":unit= '%'; break;
        case  "室内电池电量":unit= '%'; break;
        case  "室内危害气体浓度":unit= 'mg/m³'; break;
      }
      this.unit = unit;

    }
  }
}
</script>

<style scoped>

</style>
